/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('helpLauncher', {
    templateUrl: '/templates/zenclerk_s/directives/help/launcher.html',
    bindings: {
      class: '@',
      isMain: '<',
      currentProject: '<'
    },
    controller: helpLauncherController
  });

helpLauncherController.$inject = ['$element', '$scope', '$state', '$stateParams', 'Devise', 'ZcsLayout', 'ZcsProject'];
function helpLauncherController($element, $scope, $state, $stateParams, Devise, ZcsLayout, ZcsProject) {
  const vm = this;

  this.$onInit = () => {
    vm.hideMainHelp = hideMainHelp;
    vm.openProductChanges = openProductChanges;
  };

  function openProductChanges() {
    ZcsLayout.isSidebarVisible = true;
  }

  function hideMainHelp() {
    if(angular.isDefined(vm.isMain)) {
      return _.get($state, 'current.data.hideMainHelp');
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/help/launcher.js